import retailer from './reducers';

import * as retailerOperations from './operations';
import retailerTypes from './types';

export { retailerTypes, retailerOperations };

export default retailer;
